import React from 'react'
import StagesManager from '../../components/StagesManager';
// import Responsive from '../../components/Responsive';
import { checkDefaultTab, checkTranslation, translate } from '../../utils/useful';
// import NotebookSidebar from '../NotebookSidebar';
// import LoaderButton from '../../components/LoaderButton';
// import ProductsView from '../Applets/ProductsView';
import EmailList from './EmailList';
import EmailSingle from './EmailSingle';
import EmailNew from './EmailNew';
import EmailNewAccount from './EmailNewAccount';
// import SelectApplet from '../../components/useful/SelectApplet';
import { nanoid } from 'nanoid';
import Header from '../../components/header/Header';
import HttpServices from '../../utils/Http.services';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';



class EmailAdminPerspective extends React.Component {
    state = {

        headerConfig: {
            showToolbar: true, showSettings: true, showSettings: true, showFrames: 'email', type: 'email', isPortal: this.props.isPortal, title: '{{lang}}Email',
        },

        account: [
            {
                Title: "{{lang}}mail.Accounts", icon: '/assets/icons/email/add-account-gray.svg', key: "account", children: [
                    { _id: nanoid(), address: "{{lang}}mail.All Mails" },
                    { _id: nanoid(), type: "Gmail", address: "mh.mohseni98@gmailmh.mohseni98@gmail.com" },
                    { _id: nanoid(), type: "Gmail", address: "mh.mohseni77@gmail.com" },
                ]
            },
            {
                Title: "{{lang}}mail.Folders", key: "Folders", children: [
                    { type: 'inbox', address: "{{lang}}mail.Inbox", icon: "/assets/icons/email/inbox.svg" },
                    { type: 'sent', address: "{{lang}}mail.Sent", icon: "/assets/icons/email/sent.svg" },
                    { type: 'draft', address: "{{lang}}mail.Draft", icon: "/assets/icons/email/draft.svg" },
                    { type: 'archive', address: "{{lang}}mail.Archive", icon: "/assets/icons/email/archive.svg" },
                    { type: 'star', address: "{{lang}}mail.Starred", icon: "/assets/icons/email/star-blue.svg" },
                    { type: 'schedule', address: "{{lang}}mail.Schedule", icon: "/assets/icons/email/stopwatch.svg" },
                    // { type: 'more', address: "More", icon: "/assets/icons/email/arrow-down-more.svg" },
                ]
            },

        ],
        leftSideBarStage: false,
        // currentTab: 'inbox',
        currentMail: '',
        backbtn: true,
        showToolbar: true,
        bg: 'linear-gradient(90deg, #007aff, #006EE5)',
        bg2: 'rgba(0, 99, 206, 0.2)',
        toolbarView: 'email'
    }

    changeLeftSideBarStage = () => {
        this.setState({ leftSideBarStage: !this.state.leftSideBarStage })
    }


    componentDidMount() {
        this.checkDefaultTab()
    }

    forceUpdateHeader = () => {
        console.log('forceupdate')
        this.setHeader("dummy", 1)
    }

    componentDidUpdate(prevProps) {
        console.log('this.props.windowData!!', this.props.windowData.path, this.props.baseUrl)

        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {
            this.setState({ oldData: this.props.windowData }, () => {
                this.checkDefaultTab()
            })
        }
    }



    checkDefaultTab() {

        // console.log("checkDefaultTab")
        console.log('this.props.windowData!!', this.props.windowData.path, this.props.baseUrl)
        if (this.props.windowData.path.length == this.props.baseUrl.length) {
            this.stageManager.changeStage('list')
        } else if (this.props.windowData.path.length == this.props.baseUrl.length + 1 && this.props.windowData.path[this.props.windowData.path.length - 1] != 'new') {
            this.stageManager.changeStage('mail')
        }
        else if (this.props.windowData.path.length == this.props.baseUrl.length + 1 && this.props.windowData.path[this.props.windowData.path.length - 1] == 'new') {
            this.stageManager.changeStage('new')
        }
        return
        checkDefaultTab(this.props.windowData, this.props.baseUrl, this.state.modules, this.props.width, (pageInfo, pageType, def) => {


            // console.log(def)
            // console.log(pageType)
            // console.log(pageInfo)



            def = def ?? ''
            pageType = pageType != null ? pageType : def


            if (pageType != null) {

                this.setState({ oldData: this.props.windowData, path: def, pageType: pageType, page: null }, () => {

                    setTimeout(() => {
                        this.setState({ page: pageInfo, pageType, headers: pageInfo?.fields ?? pageInfo?.headers, pageStatus: 200 }, () => {
                            if (this.stageManager) {
                                this.stageManager.changeStage((pageType), () => {
                                })
                            }
                        })
                    }, 10);
                })


            } else {
                this.setState({ pageStatus: 404 })
            }

        })
    }

    // changePage = (stage, e) => {
    //     console.log('changePagechangePage')
    //     let showToolbar = false
    //     let shouldHaveToolbar = ['first',]
    //     if (shouldHaveToolbar.includes(stage)) {
    //         showToolbar = true
    //     }


    //     let showBackBtn = true
    //     let shouldHaveBackBtn = ['first',]
    //     if (shouldHaveBackBtn.includes(stage)) {
    //         showBackBtn = false
    //     }


    //     this.stageManager.changeStage(stage)
    //     this.setState({ showToolbar, showBackBtn })


    // }

    backStage = () => {
        this.stageManager.lastStage((stage) => {

            let showToolbar = false
            let shouldHaveToolbar = ['first', 0]
            if (shouldHaveToolbar.includes(stage)) {
                showToolbar = true
            }


            let showBackBtn = true
            let shouldHaveBackBtn = ['first', 0]
            if (shouldHaveBackBtn.includes(stage)) {
                showBackBtn = false
            }

            this.setState({ showToolbar, showBackBtn })

        })
    }

    changeStageFolders = (item) => {
        this.setState({ currentTab: item.type })
        this.changeStage('first')
        this.changeLeftSideBarStage()
    }


    showCheckBox = () => {
        this.setState({ checkBox: !this.state.checkBox })
    }


    setHeader = (key, value) => {

        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static',
                    showFrames: 'email', type: 'email', isPortal: this.props.isPortal, title: '{{lang}}Email',
                }
                this.state.headerConfig = { showToolbar: true, topHeaderComponent: null, backAction: null, }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }

                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }

                object.isPortal = this.props.isPortal

                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    changePage = (to) => {
        console.log('*changePage')
        if (this.props.changePage) {
            this.props.changePage(to)
        }

        // let path = Array.isArray(to) ? to : [to]
        // let fullPath = [...this.props.baseUrl, ...path]

        // console.log(fullPath)
        // this.changeWindow(fullPath)



    }
    sendMail = (data, cb) => {
        console.log('*sendMail')
        HttpServices.request('sendMail', data, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }

        })

    }

    changeWindow = (finalList) => {

        this.props.changeWindow('email', { type: 'applet', path: finalList })

    }
    functionsHandler = (type, name, data, extra) => {
        if (!type || type == 'frame' || type == 'collection') {
            if (this[name]) {
                this[name](data, extra)
            }
        } else {
            this.props.functionsHandler(type, name, data, extra)
        }
    }

    render() {
        let headertype = this.props.isApplet ? 'applet' : 'portal'
        return (
            <div className='d-flex w-100 h-100 window-content-radius ' style={{ display: 'block', backgroundColor: '#fff' }}>
                {/* <div className='' style={{ position: 'sticky', top: 0, zIndex: 9 }}>
                    <Header language={this.props.language} type={'email'} showCheckBox={this.showCheckBox} checkBox={this.state.checkBox} headertype={headertype} title={translate('Email')} types={'normal'} toolbarView={this.state.toolbarView} settingsSections={this.state.settingsSections} settings={this.state.settings} goToHub={this.props.goToHub} changeWindowLink={this.props.changeWindowLink} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changeWindow={this.changeWindow} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} color={this.state.bg} color2={this.state.bg2} toolbar={this.state.showToolbar} />
                </div> */}
                <div className="w-100  h-100  window-content-radius d-flex flex-column " ref={el => this.pageContainer = el} style={{}} >

                    {/* <div style={{ position: 'relative', top: 0 }}>
                        <Header ref={el => this.header = el} currentAccount={this.props.currentAccount} accounts={this.props.accounts} config={this.state.headerConfig} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} />
                    </div> */}


                    {/* <div className=' h-100 w-100 d-flex flex-column ' style={{ backgroundColor: '#fff' }}> */}
                    <StagesManager height={'0px'} className={'flex-1'} ref={el => this.stageManager = el} fast={true}>
                        <EmailList stageName={'list'} stage={1} language={this.props.language} changePage={this.changePage} colors={this.props.colors} setData={this.setData} setHeader={this.props.setHeader} onClick={this.changePage} applet={this.props.applet} pages={this.state.pages} width={this.props.width} height={this.props.height} changeStage={this.changeStage} changeLeftSideBarStage={this.changeLeftSideBarStage} currentAccount={this.props.currentAccount} page={this.props.page} windowData={this.props.windowData} />
                        <EmailSingle stageName={'mail'} stage={1} language={this.props.language} changePage={this.changePage} colors={this.props.colors} setData={this.setData} setHeader={this.props.setHeader} onClick={this.changePage} applet={this.props.applet} pages={this.state.pages} width={this.props.width} height={this.props.height} changeStage={this.changeStage} changeLeftSideBarStage={this.changeLeftSideBarStage} currentAccount={this.props.currentAccount} page={this.props.page} windowData={this.props.windowData} />
                        <EmailNew stageName={'new'} stage={1} language={this.props.language} changePage={this.changePage} colors={this.props.colors} setData={this.setData} setHeader={this.props.setHeader} onClick={this.changePage} applet={this.props.applet} pages={this.state.pages} width={this.props.width} height={this.props.height} changeStage={this.changeStage} changeLeftSideBarStage={this.changeLeftSideBarStage} currentAccount={this.props.currentAccount} sendMail={this.sendMail} page={this.props.page} />
                        <EmailNewAccount stageName={'account'} stage={1} language={this.props.language} changePage={this.changePage} colors={this.props.colors} setData={this.setData} setHeader={this.props.setHeader} onClick={this.changePage} applet={this.props.applet} pages={this.state.pages} width={this.props.width} height={this.props.height} changeStage={this.changeStage} changeLeftSideBarStage={this.changeLeftSideBarStage} addAccounts={this.props.addAccounts} page={this.props.page} />
                    </StagesManager>
                </div>
            </div >
        )
    }
}




const mapStateToProps = state => ({ settings: state.settings, user: state.user, connections: state.connections })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(EmailAdminPerspective);